import { IFormSchemaField } from "../types";

/**
 * Row-local visibility for a Group item field. Unlike top-level fields (whose
 * visibility the server resolves to `operations.visible`), item fields ship
 * their `visibleWhen` RAW and the FE evaluates it against the ROW's own values
 * — the engine only permits Equals/NotEquals on item fields (asserted at boot),
 * so any other operator is treated as visible.
 */
export const isItemFieldVisibleInRow = (
  field: IFormSchemaField,
  rowValues: Record<string, unknown>
): boolean => {
  const rule = field.operations.visibleWhen;
  if (!rule || rule.operator === "Always") {
    return field.operations.visible !== false;
  }
  if (rule.operator === "Equals") return rowValues[rule.ref] === rule.value;
  if (rule.operator === "NotEquals") return rowValues[rule.ref] !== rule.value;
  return true;
};
